<template>
  <div class="masteradmin">
    <header>
      <div class="navbar-fixed">
      <nav>
        <div class="nav-wrapper">
          <div class="row">
            <div class="col s12">
              <a href="#" data-target="sidenav-1" class="left sidenav-trigger hide-on-medium-and-up">
                <i class="material-icons">menu</i>
              </a>
              <h5 class="headerTitle desktopHeader">Assam Power Distribution Company Limited</h5>
              <h5 class="mobileHeader">Welcome to APDCL</h5>
            </div>
          </div>
        </div>
      </nav>
    </div>
    </header>
    <ul id="sidenav-1" class="sidenav sidenav-fixed">
      <li class="sidenav-header" style="background-color:#01579b;">
        <div class="row">
          <div class="col s12">
              <h6 style="color:white;">Welcome Admin</h6>
          </div>
        </div>
      </li>
      <li class="active"><router-link class="waves-effect textAlign" to="/usercreate">
        <i class="material-icons iconShift">person_add</i>Create User</router-link></li>
      <li ><router-link class="waves-effect textAlign" to="/tender">
        <i class="material-icons iconShift">person_pin</i>Update User</router-link></li>
      <li><router-link class="waves-effect textAlign" to="/viewusers">
        <i class="material-icons iconShift">group</i>View Users</router-link></li>
      <!--<li><router-link class="waves-effect textAlign" to="/career">
        <i class="material-icons iconShift">portrait</i>Career</router-link></li> -->

        <div class="footer-fixed">
          <footer class="footerstyle">
            <div class="footer-copyright">
              <div class="container" style="font-size:11px; text-align:center;">
              © 2020 Copyright Assam Power Distribution Company Limited, Developed by IT Cell, APDCL.
              </div>
            </div>
          </footer>
        </div>
    </ul>

    <main>
      <form id="form-add-user">
        <!-- succes modal -->
        <div id="successModal" class="modal" >
          <div class="modal-content" style="background-color:#e8f5e9  ;">
            <h4>Create New User</h4>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
              <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
              <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
            </svg>
            <p class="success">Successfully Created !</p>
          </div>
          <div class="modal-footer" style="margin-top: -7rem; background-color:#e8f5e9  ;">
            <a href="#!" class="modal-close waves-effect waves-green btn green">OK</a>
          </div>
        </div>
        <!-- error modal -->
        <div id="errorModal" class="modal">
          <div class="modal-content"  style="background-color:#ffebee;">
            <h4>Create New User</h4>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
              <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
              <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
              <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
            </svg>
            <p class="error">User Creation Failed !</p>
          </div>
          <div class="modal-footer" style="margin-top: -7rem; background-color:#ffebee;">
            <a href="#!" class="modal-close waves-effect waves-red btn red">OK</a>
          </div>
        </div>
        <div class="row">
          <div class="col s12 m2 l2 xl2 paddingTop left">
            <h6><span class="star">*</span>User ID: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <input id="userErpID" type="text" class="validate" placeholder="Enter ERP ID">
          </div>
          <div class="col s12 m2 l2 xl2 offset-m1 offset-l1 offset-xl1 paddingTop left">
            <h6><span class="star">*</span>User Name: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <input id="userName" type="text" class="validate" placeholder="Enter user name">
          </div>
        </div>
        <!-- New Row -->
        <div class="row">
          <div class="col s12 m2 l2 xl2 paddingTop left">
            <h6><span class="star">*</span>Office: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <select id="office" class="browser-default" style="background-color: #fafafa;">
              <option value="" disabled selected>Choose your option</option>
            </select>
            <!-- <input id="office" type="text" class="validate" placeholder="Enter office"> -->
            <!-- <label for="tenderDate">Enter tender date</label> -->
          </div>
          <div class="col s12 m2 l2 xl2 offset-m1 offset-l1 offset-xl1 paddingTop left">
            <h6><span class="star">*</span>Designation: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <select id="designation" class="browser-default" style="background-color: #fafafa;">
              <option value="" disabled selected>Choose your option</option>
            </select>
            <!-- <input id="designation" type="text" class="validate" placeholder="Enter designation"> -->
            <!-- <label for="bidStartDate">Enter bid start date</label> -->
          </div>
        </div>
        <!-- New Row -->
        <div class="row">
          <div class="col s12 m2 l2 xl2 paddingTop left">
            <h6><span class="star">*</span>Mobile Number: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <input id="mobile" type="text" class="validate" placeholder="Enter mobile number">
            <!-- <label for="bidEndDate">Enter bid end date</label> -->
          </div>
          <div class="col s12 m2 l2 xl2 offset-m1 offset-l1 offset-xl1 paddingTop left">
            <h6><span class="star">*</span>Email: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <input id="email" type="text" class="validate" placeholder="Enter email-id">
          </div>
        </div>
        <!-- New Row -->
        <div class="row">
          <div class="col s12 m2 l2 xl2 left">
            <h6><span class="star">*</span>Select Role: </h6>
          </div>
        </div>
        <div class="row" id="roleDiv">


          <div v-if="rolesToDisplay.length > 0">
              <div v-for="item in rolesToDisplay"  class='col s12 m3 l3 xl3 paddingCheckboxTop ' style='text-align:left'>
                <label>
                  <input type='checkbox' @change="updateArray($event, item[0])" class='filled-in' /> <span class='checkboxLabelColor' style="color:black;">{{item[1]}}</span>
                </label>
              </div>
          </div>


        </div>

        <br>
        <br>
        <!-- New Row -->
        <div class="row">
          <div class="col s3 m3 l3 xl3 offset-s3 offset-m3 offset-l3 offset-xl3">
            <button class="btn" style="background-color: #43a047;" @click="addUser($event)" type="submit" name="actionSubmit">Add User
              <i class="material-icons right">group_add</i>
            </button>
          </div>
          <div class="col s3 m3 l3 xl3">
            <button class="btn" style="background-color: #ff9800;" type="submit" name="actionReset">Reset
              <i class="material-icons right">loop</i>
            </button>
          </div>
        </div>
      </form>
    </main>
  </div>
</template>

<script>
import axios from 'axios';
var rolesToSend = [];
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://apdclrms.com/website";
const urlCommon = "https://www.apdcl.org/website";

  export default{

    data: function () {
      return {
        rolesToDisplay: []
      }
    },
    mounted(){
      var elems = document.querySelectorAll('.sidenav');
      var instances = M.Sidenav.init(elems, {});

      // alert("hello")
      // document.querySelectorAll('#office option').forEach(option => option.remove());
      axios.get(urlCommon + "/api/admin/gethqoffice").then(function(response) {
        // console.log(response);
        var x = document.getElementById("office");
        // var option = document.createElement("option");
        // option.text = "Choose your option";
        // option.value = "";
        // x.options.add(option);
        response.data.forEach(element => {
        var option = document.createElement("option");
        option.text = element[1];
        option.value = element[1];
        x.options.add(option);
        })
      })

      axios.get(urlCommon + "/api/admin/gethqdesignation").then(function(response) {
        // console.log(response);
        var y = document.getElementById("designation");
        // var option = document.createElement("option");
        // option.text = "Choose your option";
        // option.value = "";
        // x.options.add(option);
        response.data.forEach(element => {
        var option = document.createElement("option");
        option.text = element[1];
        option.value = element[1];
        y.options.add(option);
        })
      })

      const PARENT = this;
      axios.get(urlCommon + "/api/admin/getrole").then(function(response) {
        PARENT.rolesToDisplay = response.data
      })
    },
    methods:{
      updateArray(event, element) {
        if(event.target.checked){
          rolesToSend.push(element)
        }else{
          var filtered = rolesToSend.filter(function(value, index, arr){
            return value != element;
          });

          rolesToSend = filtered
        }
      },
      addUser(event){
        event.stopPropagation()
        event.preventDefault()

        // TODO: add validataion and return method

    //    var hobbies = document.getElementsByName("roles").value;
        var dataToSend = {
          "office": document.getElementById("office").value,
          "designation":document.getElementById("designation").value,
          "name":document.getElementById("userName").value,
          "user_id":document.getElementById("userErpID").value,
          "email":document.getElementById("email").value,
          "mobile_no":document.getElementById("mobile").value,
          "role": rolesToSend
        }

        console.log(dataToSend)
        // TODO: add loader

        axios.post(urlCommon + "/api/admin/createuser", dataToSend).then(function(response) {
          console.log(response)

          if (response.data == "success") {
        //    document.getElementById("form-add-user").reset()
            var elems = document.getElementById('successModal');
            var instance = M.Modal.init(elems);
            instance.open();
          } else {
            document.getElementById("form-add-user").reset()
            var elems = document.getElementById('errorModal');
            var instance = M.Modal.init(elems);
            instance.open();
          }
        })



      }
    }
  }

</script>


<style scoped="true">
.modal{
  overflow-y:hidden !important;
}

  /* header, footer {
    padding-left: 300px;
  } */
  main{
    padding-left: 350px;
  }
  .headerTitle{
    padding-left: 250px;
  }
  .mobileHeader{
    display: none;
  }
  .desktopHeader{
    display:block;
  }

  .sidenav-header {
    /* background: url("../images/user-bg.jpg") no-repeat center center; */
    background-size: cover;
    margin-bottom: 0px;
    padding: 18px 0 0 18px;
    height: 64px;
      .row {
        margin-bottom: 0;
      }
    }

    .nav-wrapper{
      background-color: #01579b ;
    }

    .paddingTop{
      padding-top: 1.5rem !important;
    }

    /* input[type=text]{
      color:black !important;
      border-bottom: 1px solid #9e9e9e !important;
    } */

    .textAlign{
      text-align: left;
    }

    .iconShift{
      margin:0px !important;
      padding: 0px 42px !important;
    }

    .star{
      color:red;
    }

    .paddingCheckboxTop{
      padding-top: .8rem !important;
    }

    .left{
      text-align: left;
    }

    .footerstyle{
      position: absolute;
      top: calc(100vh - 57px);
    }
    svg {
      width: 100px;
      display: block;
      margin: 40px auto 0;
    }
    .path {
      stroke-dasharray: 1000;
      stroke-dashoffset: 0;
    }
    .path.circle {
      -webkit-animation: dash 0.9s ease-in-out;
      animation: dash 0.9s ease-in-out;
    }
    .path.line {
      stroke-dashoffset: 1000;
      -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
      animation: dash 0.9s 0.35s ease-in-out forwards;
    }
    .path.check {
      stroke-dashoffset: -100;
      -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
      animation: dash-check 0.9s 0.35s ease-in-out forwards;
    }
    p {
      text-align: center;
      margin: 20px 0 60px;
      font-size: 1.25em;
    }
    p.success {
      color: #73AF55;
    }
    p.error {
      color: #D06079;
    }
    @-webkit-keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @-webkit-keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }
    @keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }


  @media only screen and (max-width : 992px) {
    header, main, footer {
      padding-left: 0 !important;
    }
    .headerTitle{
      padding-left: 0;
    }
    .mobileHeader{
      display: block;
    }
    .desktopHeader{
      display:none;
    }
    .paddingTop{
      padding-top: 0 !important;
    }
  }
</style>
